<mat-card class="card-style-full px-6 py-6 pt-0">
  <mat-card-header class="flex justify-between items-center">
    <mat-card-title class=""
    >Cadastro Município</mat-card-title
    >
    <button class="btn-icon" (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </mat-card-header>

  <div [formGroup]="form" class="mt-8 mb-0">
    <div>
    <div class="flex justify-between gap-4 items-center">
      <mat-form-field class="input-tg w-2/12" appearance="outline">
        <mat-label>Código</mat-label>
        <input matInput formControlName="code" />
      </mat-form-field>
      <mat-form-field class="input-tg w-5/12" appearance="outline">
        <mat-label>Descrição</mat-label>
        <input matInput formControlName="description" />
      </mat-form-field>
      <mat-slide-toggle
        class="input-tg w-5/12 px-2"
        formControlName="active"
      >Status:
        <strong>{{
            form.get('active')?.value ? 'Ativo' : 'Inativo'
          }}</strong></mat-slide-toggle
      >

    </div>
  </div>
    <div class="flex justify-end mt-3">
      <button
        mat-flat-button
        class="btn-tg w-1/5"
        [disabled]="!form.valid || loading"
        (click)="editLocation()"
      >
        @if (loading) {
          <mat-spinner diameter="22" class="loading-spinner"></mat-spinner>
        } @else {
          Editar
        }
      </button>
    </div>
  </div>
</mat-card>
